import Cookies from 'js-cookie'

export function getToken (keyStr) {
  return Cookies.get(keyStr)
}

export function setToken (keyStr, valueStr) {
  return Cookies.set(keyStr, valueStr, { expires: 7 })
}

export function removeToken (keyStr) {
  return Cookies.remove(keyStr)
}
